@if (shouldShow) {
  <app-clearance [clearance]="clearance" clearanceKey="emgs">
  </app-clearance>
}
